import { z } from 'zod';

import { codec, useQueryParams } from '@/hooks/router/use-query-params';

const sep = '|';

export type DetailsId = {
  type: 'email' | 'meeting';
  id: string;
};

export function useDetailsId(): [
  DetailsId | undefined,
  (detailsId: DetailsId | undefined) => void,
] {
  const [params, history] = useQueryParams({
    encodedIdType: {
      key: 'id',
      schema: z.string().optional(),
      codec: codec.string,
    },
  });

  function update(detailsId: DetailsId | undefined) {
    history.push({
      encodedIdType: detailsId
        ? `${detailsId.type}${sep}${detailsId.id}`
        : undefined,
    });
  }

  const decodedDetailsId = params.encodedIdType?.split(sep) ?? [];

  if (decodedDetailsId.length < 2) {
    return [undefined, update];
  }

  const [type, id] = decodedDetailsId as [DetailsId['type'], DetailsId['id']];

  return [{ id, type }, update];
}
